//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {declOfNum, getArrForTitle, getContentByCode} from "@/utils/utils";

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imgWidth: 'auto'
    }
  },
  mounted() {
    setTimeout(() => {
      const img = document.querySelector(`#card-img-${this.item.id}`)
      this.imgWidth = img ? img.offsetWidth+'px' || 'auto' : 'auto'
    }, 800)
  },
  methods: {
    pictureUrl(url) {
      return this.$absoluteImageUrl(url)
    },
    getDeclination(num, key){
      if (this.$i18n.locale === 'en') {
        return this.$tc(key, num > 1 ? 2 : 1)
      } else {
        return this.$tc(key, declOfNum(num));
      }
    },
  }
}
